import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Switch } from "../components/ui/switch";
import { Bell, Mail, Shield } from "lucide-react";
import { toast } from "sonner";

export default function Settings() {
  const { role, user, loading, refresh } = useAuth();
  const nav = useNavigate();
  const [emailNotifOnCalled, setEmailNotifOnCalled] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (role !== "client") { nav("/"); return; }
    setEmailNotifOnCalled(user?.emailNotifOnCalled !== false);
  }, [loading, role, user, nav]);

  const toggleEmailNotif = async (next) => {
    setSaving(true);
    setEmailNotifOnCalled(next);
    try {
      await api.patch("/users/me/preferences", { emailNotifOnCalled: next });
      toast.success(next ? "Notifications email activées" : "Notifications email désactivées");
      await refresh();
    } catch (err) {
      setEmailNotifOnCalled(!next);
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  if (role !== "client") return null;

  return (
    <div className="container mx-auto px-4 md:px-8 py-10 md:py-14 max-w-3xl">
      <p className="overline mb-2">Mon compte</p>
      <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter text-ink">Paramètres</h1>

      <section className="mt-10 border border-border" data-testid="settings-notifications">
        <div className="p-5 border-b border-border bg-surface">
          <div className="flex items-center gap-2">
            <Bell size={16} className="text-brand" />
            <h2 className="font-display font-bold text-ink">Notifications</h2>
          </div>
          <p className="text-xs text-subtle mt-1">Recevoir une alerte quand votre ticket est appelé.</p>
        </div>

        <div className="p-5 flex items-center justify-between gap-4">
          <div className="flex items-start gap-3 min-w-0">
            <Mail size={18} className="text-ink mt-0.5 shrink-0" />
            <div className="min-w-0">
              <p className="font-medium text-ink">Email quand je suis appelé</p>
              <p className="text-xs text-subtle mt-0.5">
                Un email est envoyé à <strong>{user?.email}</strong> dès que l'établissement appelle votre numéro, en plus du son et de la notification navigateur.
              </p>
            </div>
          </div>
          <Switch
            checked={emailNotifOnCalled}
            disabled={saving}
            onCheckedChange={toggleEmailNotif}
            data-testid="toggle-email-notif-called"
          />
        </div>

        <div className="p-5 border-t border-border bg-surface/50">
          <div className="flex items-start gap-3">
            <Shield size={16} className="text-subtle mt-0.5 shrink-0" />
            <p className="text-xs text-subtle">
              Le son et la vibration sont activés automatiquement dès que l'onglet est ouvert. Les notifications navigateur nécessitent votre autorisation au premier ticket.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
